import { CustomizeOutlineIcon } from '@carboncopyco/icons';
import {
  ColorHex,
  Dropdown,
  MultiDropdownFilterItem,
  TextBoxEditorTitle,
  TextTooltip,
  Tooltip,
} from '@carboncopyco/ui';
import { getMaxZIndex } from '@carboncopyco/utils';
import type { Column } from '@tanstack/react-table';
import { useRef } from 'react';

type ColumnsFilterProps = {
  columns: Column<Record<string, unknown>, unknown>[];
};

export const ColumnsFilter = ({ columns }: ColumnsFilterProps) => {
  const currentRef = useRef(null);

  return (
    <>
      <Dropdown
        triggerElement={
          <span
            ref={currentRef}
            className="cursor-pointer"
          >
            <CustomizeOutlineIcon
              size={16}
              color={ColorHex.natural600}
            />
          </span>
        }
      >
        <div className="py-2 px-1 flex flex-col gap-3">
          <div className="px-1">
            <TextBoxEditorTitle
              label="Display columns"
              uppercase
              color="text-ds-natural-300"
              fontWeight="font-ds-medium"
            />
          </div>
          <div className="max-h-[180px] overflow-y-auto overflow-hidden">
            {columns.map(({ id, columnDef, ...column }) => {
              if (id === 'rowActions') return null;
              return (
                <MultiDropdownFilterItem
                  key={id}
                  checked={column.getIsVisible()}
                  onChange={() => column.toggleVisibility()}
                  item={{
                    label: columnDef.header as string,
                    id,
                  }}
                />
              );
            })}
          </div>
        </div>
      </Dropdown>
      <Tooltip
        zIndex={getMaxZIndex() + 1}
        offset={[0, 2]}
        delay={[700, 0]}
        placement="top"
        anchorRef={currentRef}
        noArrow
        background="dark"
        shadow="lg"
      >
        <div className="px-1.5 pb-1 pt-0 leading-none">
          <TextTooltip
            label="Display columns"
            color="text-ds-natural-50"
          />
        </div>
      </Tooltip>
    </>
  );
};
